import React from 'react';
import './ErrorBoundary.less';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="errorBoundaryReplacementUI">
          Something went wrong trying to display this page. Try refreshing.
          <br/>
          <br/>
          If the issue persists, please email us at <a target="_blank" href="mailto:editor@dailybaffle.com">editor@dailybaffle.com</a> and we'll get on it.
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;